import React, {Component} from 'react';
import { Platform, Dimensions, Keyboard, View, Image, KeyboardAvoidingView,
         Text, TextInput, StyleSheet, TouchableHighlight } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import LinearGradient from 'react-native-linear-gradient';
import MessageBox from "../ui/MessageBox";
import RoomClient from "../../utils/chinesepark/RoomClient";
import IsMobile from "../../utils/IsMobile";
import { Button, } from "native-base";
import { withTranslation } from "react-i18next";
//import FastImage from 'react-native-fast-image';
import UIDs from "../../UIDs";
import _ from 'lodash';

const uid = UIDs.screens.chinesepark.room;

class ChatInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const isFollowed = this.props.roomInfo.isFollowed;
        const isMyRoom = (RoomClient.getUserId() === this.props.roomInfo.ownerId);
        const isMobile = IsMobile();
        return (<View style={this.props.style || {height: 40, flexDirection: 'row', alignItems: 'center'}}>
                {/*
                <Button transparent style={{width: 30, height: 30, marginLeft: 6,
                                            alignItems: 'center', justifyContent: 'center',
                                            backgroundColor: '#f1f1f1', borderRadius: 15}}
                onPress={() => this.props.onShare()}>
                <Icon name="ios-person-add" style={{ fontSize: 24, color:"#f84070" }}/>
                </Button>
                 */}
                {/*isMyRoom ? null :
                 (<Button transparent style={{height: 30, paddingLeft: 0, paddingRight: 0,
                                              marginLeft: 6, paddingTop: 0, paddingBottom: 0,
                                              backgroundColor: '#49d273', borderRadius: 15}}
                  onPress={() => {
                      this.props.onFollow();
                  }}>
                  <LinearGradient start={{ x : 0.0, y : 0 }} end={{ x : 1, y : 0 }}
                  colors={['#3dd078', '#a2e053']} style={{flexDirection: 'row', alignItems: 'center',
                                                          height: 30, borderRadius: 15,
                                                          paddingLeft: 8, paddingRight: 8,}}>
                  <Text style={{ fontSize: 14, color:"#fff"}}>{isFollowed ? this.props.t("followed") : this.props.t("follow")}</Text>
                  </LinearGradient>
                  </Button>)*/}
                <View style={{flex: 1, flexDirection: 'row', alignItems: 'center',
                              height: 30, borderRadius: (isMobile ? 15 : 6), backgroundColor: '#383838',
                              marginLeft: (isMobile ? 10 : 4), marginRight: (isMobile ? 8 : 8),
                              paddingLeft: (isMobile ? 8 : 8), paddingRight: (isMobile ? 8 : 0),
                              overflow: 'hidden'}}>
                    <TextInput ref="TEXT_INPUT" style={{ flex: 1, fontSize:14, minWidth: 0,
                                                         paddingTop: 0, paddingBottom: 0, color: '#f5f5f5' }}
                               onChangeText={text => this.setState({text: text})}
                               placeholder={this.props.t("say a few words")}
                               placeholderTextColor='#999999'
                               value={this.state.text} maxLength={1000}
                               onSubmitEditing={(e) => {
                                   this._handleSendMessage();
                               }}
                               customIMECandidates={true}/>
                    {isMobile ? null :
                     (<Button transparent style={{height: 30, paddingLeft: 8, paddingRight: 8,
                                                  marginLeft: 0, marginRight: 0,
                                                  paddingTop: 0, paddingBottom: 0,
                                                  backgroundColor: '#0e5dc6', borderRadius: 0}}
                            onPress={() => this._handleSendMessage()}>
                        <Text style={{ fontSize: 14, color:"#fff"}}>{this.props.t("send")}</Text>
                      </Button>)}
                </View>
                {this.state.text && isMobile ?
                 (<Button transparent style={{height: 30, paddingLeft: 8, paddingRight: 8,
                                              marginLeft: 0, marginRight: 6, paddingTop: 0, paddingBottom: 0,
                                              backgroundColor: '#49d273', borderRadius: 4}}
                  onPress={() => this._handleSendMessage()}>
                  <Text style={{ fontSize: 14, color:"#fff"}}>{this.props.t("send")}</Text>
                  </Button>) : null}
                {this.props.onReward ?
                    (<Button transparent style={{width: 30, height: 30,
                                                marginRight: (isMobile ? 8 : 0),
                                                alignItems: 'center', justifyContent: 'center',
                                                backgroundColor: '#383838', borderRadius: 15}}
                            onPress={() => this.props.onReward()}>
                        <Image source={require('../../images/chinesepark/reward.png')}
                               style={{width: 30, height: 30}}/>
                    </Button>) : null}
                    {isMobile ?
                     (<Button transparent style={{width: 30, height: 30, marginRight: 10, 
                                                  alignItems: 'center', justifyContent: 'center',
                                                  backgroundColor: '#383838', borderRadius: 15}}
                              onPress={() => this.props.onShare()}>
                          <Image source={require('../../images/chinesepark/share.png')}
                                 style={{width: 30, height: 30}}/>
                      </Button>) : null}
                </View>
        );
    }

    _handleSendMessage = () => {
        const text = this.state.text;
        if (text) {
            RoomClient.sendChatMsg({text: text}, (resp) => {
                if (resp.error) {
                    MessageBox.show({
                        text: this.props.t(resp.message),
                        position: "top",
                        duration: 5000
                    });
                }
                else {
                    this.props.chatStore.addTextMsg(RoomClient.getUser(RoomClient.userid), text);
                }
            });
        }

        this.setState({text: ''}, () => {
            this.refs["TEXT_INPUT"].focus();
        });
    };
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default withTranslation(uid, { withRef: true })(ChatInput);
